import React, {Component} from "react";

export const OAUTH_CALLBACK_PATH = '/oauth/callback';

class OAuthManager extends Component {

    constructor(props) {
        super(props)
        this.state = {
            frame: null,
            timer: null
        }
    }

    _openedAt = null;

    showAuthDialog = (url) => {
        const { onDismiss, onError, onOpen, onComplete } = this.props;

        if (url && url !== '') {
            // Clear any stale signal
            localStorage.removeItem('oauth_complete');
            this._openedAt = Date.now();

            let frameHeight = 680
            let frameWidth = 650
            let frame = window.open(url,"oauthWindow",`menubar=0,resizable=1,width=${frameWidth},height=${frameHeight},left=${(window.screen.width-frameWidth)/2},top=${(window.screen.height-frameHeight)/2}`);

            if (!frame || frame.closed || typeof frame.closed=='undefined') {
                onError && onError({ type: 'error', message: 'Authentication pop-up blocked. Please whitelist the pop-up and try again.'});
            } else {
                onOpen && onOpen();
                frame.focus();
            }

            let poll = setInterval(() => {
                const completedAt = localStorage.getItem('oauth_complete');
                // Check localStorage even if popup hasn't closed (window.close() can be blocked)
                if (completedAt && Number(completedAt) >= this._openedAt) {
                    clearInterval(poll)
                    localStorage.removeItem('oauth_complete');
                    this.setState({frame: null, timer: null})
                    if (frame && !frame.closed) frame.close();
                    onComplete && onComplete();
                } else if (frame?.closed) {
                    clearInterval(poll)
                    this.setState({frame: null, timer: null})
                    onDismiss && onDismiss();
                }
            }, 500);

            this.setState({frame: frame, timer: poll})
        }
    }

    destroyAuthDialog = () => {
        let { frame, timer } = this.state

        if (frame) {
            frame.close()
            this.setState({frame: null})
        }

        if (timer) {
            clearInterval(timer)
            this.setState({timer: null})
        }
    }

    componentWillUnmount() {
        this.destroyAuthDialog()
    }

    render() {
        return(
            <React.Fragment/>
        )
    }
}

export default OAuthManager;
